import React, { useLayoutEffect, useState } from "react";
import DynamicForm from "components/DynamicForm";
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Container, Row } from "reactstrap";
import form from 'formConfigs/addPackage';
import Heading from "components/Heading";
import { errorHandler } from "utils/Api";
import { showAlert } from "utils/Alert";
import { getPackage, savePackage } from "api/PackagesApi";
import { getTypeCounterByName } from "api/TypeCounterApi";
import { sequenceGenerator } from "utils/Form";
import { PACKAGE_NOTIFICATIONS, SEQUENCETYPES } from "utils/Constants";
import FileUploadInput from "components/DynamicForm/components/FileUploadInput";

const AddPackage = props => {
  let navigate = useNavigate();
  let { id: packageId } = useParams();
  const [packageData, setPackageData] = useState({});
  const [adviceFiles, setAdviceFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    if (packageId) {
      setIsLoading(true);
      loadPackageData(packageId);
    } else {
      generatePackageId();
    }
  }, [packageId]);

  const generatePackageId = async () => {
    const counter = await getTypeCounterByName(SEQUENCETYPES.BOX);
    const packageNumber = sequenceGenerator(SEQUENCETYPES.BOX, counter);
    setPackageData({
      ...packageData,
      secuencia: packageNumber
    });
  }

  const loadPackageData = (packageId) => {
    getPackage(packageId).then((packageObject) => {
      setPackageData(packageObject);
      const adviseDataFiles = (packageObject.boxAssets && packageObject.boxAssets.items) || []
      setAdviceFiles(adviseDataFiles);
    }).catch((e) => console.log("fetch package data error", e))
      .finally(() => { setIsLoading(false) });
  }

  const addPackage = (data) => {
    setIsLoading(true);
    data = checkForRecieveNotification(data);
    savePackage(data, adviceFiles).then(async (r) => {
      const packageAlert = (data && data.id) ? "" : `. El numero de paquete es ${r.secuencia} `;
      showAlert("success",
        `Paquete ${((data && data.id) ? "actualizado" : "creado")} exitosamente${packageAlert}`
      );
      navigate("/admin/packages");
    }).catch(e => {
      errorHandler(e);
      showAlert("danger", "No fue posible guardar la informacion del paquete");
    }).finally(() => { setIsLoading(false) });

  };

  const checkForRecieveNotification = (data) => {
    if (!data.received && !packageData.warehouseNumber && data.warehouseNumber) {
      return {
        ...data,
        received: true,
        notificationNeeded: true,
        notificationType: PACKAGE_NOTIFICATIONS.PACKAGE_RECEIVED
      };
    }

    return data;
  }

  const onUpdateFiles = (files) => {
    setAdviceFiles(files);
  }

  return (
    <>
      <Heading yellowBg={true} headingLevel="h2" className="pt-4 pb-4" label="Datos de Paquetes" sticky bordered >
        <Col sm={2}>
          <Row>
            <Col>
              <Button color="danger" onClick={(e) => { navigate("/admin/packages") }}> Cerrar</Button>
            </Col>
            <Col >
              <Button className="float-end" form="addPackage" type="submit" color="success"> Guardar</Button>
            </Col>
          </Row>
        </Col>
      </Heading>
      <Container>
        <DynamicForm
          id="addPackage"
          externalFormState={packageData}
          formConfig={form}
          isLoading={isLoading}
          onSubmit={addPackage} >
          <Container>
            <Row className="justify-content-md-center">
              <Heading headingLevel="h3" className="pt-4 pb-4" label="Archivos de Paquete" />
              <Col sm={8}>
                <FileUploadInput
                  files={adviceFiles}
                  maxFiles={10}
                  allowMultiple={true}
                  onUpdateFiles={onUpdateFiles}
                  name="files"
                  labelIdle="Arrastre los documentos del paquete en este area"
                />
              </Col>
            </Row>
          </Container>
        </DynamicForm>
      </Container>
    </>
  );
}

export default AddPackage;
